import React, { useState, useMemo } from "react";
import { useTheme } from "../context/ThemeContext";

interface NavbarMovementProps {
  options: string[];
  onSelect?: (selected: string) => void;
}

const NavbarMovement: React.FC<NavbarMovementProps> = ({
  options,
  onSelect,
}) => {
  const { theme, departmentColor } = useTheme();

  const PRIMARY_COLOR = departmentColor || theme?.primary || "#0a343d";

  const [selected, setSelected] = useState<string>(options[0] || "");

  const handleSelect = (option: string) => {
    setSelected(option);
    if (onSelect) onSelect(option);
  };

  const containerStyle = useMemo<React.CSSProperties>(
    () => ({
      width: "100%",
      backgroundColor: "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily:
        "'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
      marginTop: "50px",
      padding: "6px 0",
    }),
    []
  );

  const optionStyle = useMemo<React.CSSProperties>(
    () => ({
      minHeight: "36px",
      padding: "0 18px",
      fontSize: "14px",
      fontWeight: 500,
      letterSpacing: "0.02em",
      color: PRIMARY_COLOR,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 8px",
      borderRadius: "0px",
      backgroundColor: "transparent",
      border: `1px solid ${PRIMARY_COLOR}`,
      boxSizing: "border-box",
      transition: "all 0.18s ease-out",
      userSelect: "none",
    }),
    [PRIMARY_COLOR]
  );

  const selectedStyle = useMemo<React.CSSProperties>(
    () => ({
      backgroundColor: PRIMARY_COLOR,
      color: "#FFFFFF",
      boxShadow: "0 2px 6px rgba(0,0,0,0.18)",
    }),
    [PRIMARY_COLOR]
  );

  return (
    <div style={containerStyle}>
      {options.map((option) => {
        const isSelected = selected === option;

        return (
          <div
            key={option}
            onClick={() => handleSelect(option)}
            style={{
              ...optionStyle,
              ...(isSelected ? selectedStyle : {}),
            }}
          >
            {option}
          </div>
        );
      })}
    </div>
  );
};

export default NavbarMovement;
